import {
    SettingsVariable,
    UpdateVariableInput,
} from '../../../services/api/departmentVariablesService';
import { DepartmentUser } from '../utils/settingsView';

export interface VariableDraft {
    value: string;
    refId?: string;
    label: string;
    category: string;
}

export function displayValue(
    variable: SettingsVariable,
    users: DepartmentUser[]
): string {
    if (variable.refId) {
        return users.find((user) => user.id === variable.refId)?.name ?? '';
    }
    return variable.fixedValue || '';
}

export function buildUpdateInput(
    variable: SettingsVariable,
    draft: VariableDraft,
    currentLabel: string
): UpdateVariableInput {
    const label = draft.label.trim();
    return {
        label: variable.renamable && label !== currentLabel ? label : undefined,
        category:
            draft.category !== variable.category ? draft.category : undefined,
        fixedValue: draft.refId ? undefined : draft.value || undefined,
        refId: draft.refId,
    };
}

export function hasValueChange(
    variable: SettingsVariable,
    draft: VariableDraft
): boolean {
    return (
        draft.refId !== variable.refId ||
        draft.value !== (variable.fixedValue ?? '')
    );
}

export function canSaveVariable(
    variable: SettingsVariable,
    draft: VariableDraft,
    currentLabel: string,
    inUse = false
): boolean {
    const input = buildUpdateInput(variable, draft, currentLabel);
    const hasChange =
        hasValueChange(variable, draft) ||
        input.label !== undefined ||
        input.category !== undefined;
    const hasLabel = !variable.renamable || draft.label.trim().length > 0;
    const hasValue =
        (variable.fixed && !inUse) ||
        !!draft.refId ||
        draft.value.trim().length > 0;
    return hasChange && hasLabel && hasValue;
}
